<div class="backdrop" (click)="closeModal()"></div>

<div class="modal cyber-modal">
  
  <div class="modal-header">
    <div class="header-title">
      <span *ngIf="!loading">>_ INICIALIZACIÓN: PASO {{ currentStep }}/3</span>
      <span *ngIf="loading" class="text-neon">>_ GENERANDO PIPELINE IA...</span>
    </div>
    <button class="close-btn" (click)="closeModal()">
      <svg viewBox="0 0 24 24" width="22" height="22"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
    </button>
  </div>
  
  <div class="modal-body">
    <ng-container *ngIf="loading; else stepsContentTpl">
        <div style="width: 100%; height: 100%; display: flex; flex-direction: column;">
          <app-terminal 
              style="display: block; flex: 1; min-height: 0;"
              [text]="streamingText" 
              [title]="'>_ Ejecutando RAGPT'"
              [height]="'100%'">
          </app-terminal>
        </div>
    </ng-container>

    <ng-template #stepsContentTpl>
        <ng-container *ngIf="currentStep === 1">
            <div class="step-container">
              <h3 class="step-title">Asistente de Estimación IA</h3>
              <p class="step-desc">
                Bienvenido a la creación de estimaciones de proyectos. Con la ayuda de la Inteligencia Artificial,
                vamos a crear las tareas necesarias para desarrollar tu proyecto, partiendo del alcance del mismo o de los requisitos.
              </p>
              <p class="step-desc">
                A continuación, indica el alcance o requisitos del proyecto para proceder a su descomposición en tareas y su estimación.
              </p>
            </div>
          </ng-container>
          
          <ng-container *ngIf="currentStep === 2">
            <div class="step-container" style="height: 100%; display: flex; flex-direction: column;">
              <label class="cyber-label">>_ INGRESE EL ALCANCE / REQUISITOS</label>
              <textarea class="form-control cyber-prompt" [(ngModel)]="newEstimation.prompt" maxlength="50000" placeholder=">_ Describa aquí el alcance técnico..."></textarea>
              <div class="char-counter" [class.limit]="newEstimation.prompt.length >= 50000">
                {{ newEstimation.prompt.length || 0 }} / 50000
              </div>
            </div>
          </ng-container>
          
          <ng-container *ngIf="currentStep === 3">
            <div class="step-container">
              <label class="cyber-label" style="margin-bottom: 10px; display: block;">>_ METADATA DEL PROYECTO</label>
              <app-estimacion-details [estimation]="newEstimation"></app-estimacion-details>
            </div>
          </ng-container>
    </ng-template>
  </div>

  <div class="modal-footer" *ngIf="!loading">
    <button class="btn secondary" (click)="previousStep()" [disabled]="currentStep === 1">Anterior</button>
    <div class="spacer"></div>
    <button class="btn secondary" (click)="nextStep()" *ngIf="currentStep < 3">Siguiente</button>
    <button class="btn primary btn-glow" (click)="calculateEstimation()" *ngIf="currentStep === 3">
      <svg viewBox="0 0 24 24" width="16" height="16" style="margin-right: 6px;"><path fill="currentColor" d="M19 3h-1V1h-2v2h-1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-4V5h4v14zM7 10h2v7H7zm-4 3h2v4H3z"/></svg>
      Sintetizar
    </button>
  </div>
</div>